export default {
  p1: [
    'Did you know that if the FDA doesn’t approve your first submission, you will have to wait around '
    + '435 days to have a second submission approved? This means that your plans, marketing '
    + 'efforts, and project goals will be postponed, not to mention the high costs of a resubmission. '
    + 'However, you can avoid all this hassle if you make the right regulatory submission decisions.',
    'The regulatory affairs experts at STATECS can highly ease the process for you by ensuring your '
    + 'submission gets FDA approved. We will thoroughly review your content to see if it’s compliant '
    + 'with all the FDA standards and improve/correct anything that can be a reason for rejection.',
  ],
  p2: [
    'Our experts will check your submission content from all possible aspects:',
    '●\tData formatting and submission review to ensure they meet the proper data standards.',
    '●\tDiscovering uncommon data patterns that can make an FDA reviewer skeptical of the '
    + 'quality of your study and lead them to investigate further.',
    '●\tDiscovering uncommon data patterns that can make an FDA reviewer skeptical of the '
    + 'quality of your study and lead them to investigate further.',
  ],
  p3: [
    'Your submission will be carefully reviewed having every minute detail in mind. We will act as a\n'
    + 'liaison between you and the FDA ensuring that the product you want to release meets all the\n'
    + 'FDA regulations and that its approval will improve patient health and safety.',
  ],
  p4: [
    {
      title: 'What We Bring To The Table',
      context: 'Our regulatory affairs experts are highly skillful and knowledgeable in what they do. They have '
        + 'extensive knowledge of all the phases of the FDA approval process:',
    },
  ],
  p5: [
    '●\tComprehensive knowledge of the regulatory requirements for doing clinical trials',
    '●\tInsights into the latest clinical trial and submission requirements.',
    '●\tExpertise in helping many prominent pharmaceutical companies comply with the '
    + 'above-mentioned regulations and get approved by the FDA.',
  ],
  p6: [
    'STATECS also provides you with CDISC compliance and will ensure the corresponding standards '
    + 'are met before sending your submission.',
    'Choose us as your guide in the regulatory submission process and rest assured that your '
    + 'product/service will comply with the FDA Data Standards Catalog.',
  ],
};
